import { TableHTMLAttributes } from 'react';

export type TableProps = TableHTMLAttributes<HTMLTableElement>;
export const Table = ({ children, className, ...rest }: TableProps) => (
  <table className={[className, 'border', 'border-fg-150', 'border-collapse'].join(' ')} {...rest}>
    {children}
  </table>
);
